import { GalleryTranslate } from './galleryTranslateEN';

const galleryTranslatePTBR: GalleryTranslate = {
  section: {
    title: 'Galerias',
    createButton: 'Nova galeria',
    manageButton: 'Gerenciar',
    emptyState: 'Nenhuma galeria criada ainda',
    photosCount_one: '{{count}} foto',
    photosCount_other: '{{count}} fotos',
    selectedCount: '{{selected}} de {{total}} selecionadas',
    confirmedAt: 'Seleção confirmada em {{date}}',
    status: {
      DRAFT: 'Rascunho',
      PUBLISHED: 'Publicada',
      ARCHIVED: 'Arquivada',
    },
  },
  createModal: {
    title: 'Nova galeria',
    fields: {
      name: 'Nome da galeria',
      event: 'Evento relacionado',
      noEvent: 'Sem evento',
      selectionLimit: 'Limite de seleção',
      clientMessage: 'Mensagem ao cliente',
    },
    errors: {
      nameRequired: 'Informe um nome para a galeria',
      selectionLimitMin: 'O limite deve ser no mínimo 1',
    },
    submit: 'Criar galeria',
    cancel: 'Cancelar',
  },
  manageModal: {
    title: 'Gerenciar galeria',
    uploadButton: 'Adicionar fotos',
    uploadHint: 'JPEG, PNG ou WebP até 15MB',
    emptyPhotos: 'Nenhuma foto ainda',
    selectedSummary: 'O cliente selecionou {{selected}} de {{total}}',
    selectionPending: 'Aguardando a seleção do cliente',
    publicUrlLabel: 'Link público',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
    publish: 'Publicar',
    archive: 'Arquivar',
    delete: 'Excluir',
    removePhoto: 'Remover foto',
    clearFinished: 'Limpar concluídos',
    queue: {
      uploading: 'Enviando',
      success: 'Concluído',
      error: 'Falhou',
    },
    uploadErrors: {
      tooLarge: 'Arquivo muito grande (máximo 15MB)',
      invalidType: 'Tipo de arquivo não suportado',
      invalidContent: 'O conteúdo do arquivo não corresponde ao tipo',
      processingFailed: 'Não foi possível processar a imagem',
      uploadFailed: 'Falha no envio',
    },
    publishConfirm: {
      title: 'Publicar galeria',
      text: 'Depois de publicada, o cliente poderá acessar o link e começar a selecionar as fotos.',
      confirm: 'Publicar',
      cancel: 'Cancelar',
    },
    archiveConfirm: {
      title: 'Arquivar galeria',
      text: 'Arquivar oculta a galeria do cliente. Você pode revisá-la depois.',
      confirm: 'Arquivar',
      cancel: 'Cancelar',
    },
    deleteConfirm: {
      title: 'Excluir galeria',
      text: 'Isso removerá permanentemente a galeria e suas fotos.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
  },
  public: {
    loading: 'Carregando galeria...',
    notFoundTitle: 'Galeria não encontrada',
    notFoundText:
      'Este link pode ser inválido ou a galeria não está mais disponível.',
    selectionCounter: '{{selected}} de {{limit}} selecionadas',
    selectionCounterNoLimit: '{{selected}} selecionadas',
    confirmButton: 'Confirmar seleção',
    confirmedBadge: 'Seleção confirmada',
    confirmedAt: 'Confirmada em {{date}}',
    stillEditable:
      'Você ainda pode ajustar sua seleção enquanto a galeria estiver aberta.',
    saving: 'Salvando...',
    saved: 'Alterações salvas',
    limitReached: 'Você atingiu o limite de seleção',
    extrasInfo:
      'Você atingiu o limite do pacote — as próximas fotos contam como extras',
    selectPhoto: 'Selecionar foto',
    deselectPhoto: 'Desmarcar foto',
    openPhoto: 'Abrir foto',
    closeLightbox: 'Fechar',
    prevPhoto: 'Foto anterior',
    nextPhoto: 'Próxima foto',
    confirmModal: {
      title: 'Confirmar seleção',
      text: 'Depois de confirmar, o fotógrafo será avisado. Você ainda pode ajustar sua seleção enquanto a galeria estiver aberta.',
      textExtras_one:
        'Sua seleção inclui {{count}} foto extra além do pacote; ela pode ser cobrada à parte.',
      textExtras_other:
        'Sua seleção inclui {{count}} fotos extras além do pacote; elas podem ser cobradas à parte.',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    toasts: {
      confirmed: 'Seleção confirmada',
      confirmError: 'Não foi possível confirmar a seleção',
      saveError: 'Não foi possível salvar sua seleção',
    },
  },
  extrasCount_one: '{{count}} extra',
  extrasCount_other: '{{count}} extras',
  toasts: {
    created: 'Galeria criada',
    createError: 'Não foi possível criar a galeria',
    published: 'Galeria publicada',
    publishError: 'Não foi possível publicar a galeria',
    archived: 'Galeria arquivada',
    archiveError: 'Não foi possível arquivar a galeria',
    removed: 'Galeria excluída',
    removeError: 'Não foi possível excluir a galeria',
    photoRemoved: 'Foto removida',
    photoRemoveError: 'Não foi possível remover a foto',
  },
};

export default galleryTranslatePTBR;
